import { Injectable, inject } from '@angular/core';
import { catchError, of, switchMap, Observable } from 'rxjs';

import { ReportGroupFilterListingService } from 'src/app/services/api/report-group-filter/report-group-filter-listing.service';
import { DevicesDataService } from 'src/app/services/data/devices-data/devices-data.service';
import {
  DEVICE_TYPES,
  STATUSES,
  HEALTH,
  LAST_HEARD,
  BATTERY_STATUS,
  VALID_TRANSMISSION_READ_RATE
} from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import {
  DeviceTypeGroup,
  FilterModel,
  FilterModels,
  ListingFiltersSource
} from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';

@Injectable()
export class SensorsListingFiltersSourceService implements ListingFiltersSource {
  readonly devices = inject(DevicesDataService);
  readonly reportGroupFilterService = inject(ReportGroupFilterListingService);

  readonly #applicable = 'AMI Health Dashboard';

  getAll(): Observable<FilterModels> {
    return this.getReportGroup().pipe(
      switchMap(reportGroupFilter => {
        return of([
          reportGroupFilter,
          DEVICE_TYPES[DeviceTypeGroup.Sensors],
          STATUSES,
          HEALTH,
          LAST_HEARD,
          BATTERY_STATUS,
          VALID_TRANSMISSION_READ_RATE
        ]);
      }),
      catchError(error => {
        return of(error);
      })
    );
  }

  getReportGroup(): Observable<FilterModel> {
    return this.reportGroupFilterService.getFilter(this.#applicable);
  }
}
